import { gql } from "@apollo/client";
import { AtsTicketDetails } from "../../../maps/queries/types";
import { AtsStckItem, AtsStckItemDetails } from "./types";
import { EmpMaster } from "../../../users/queries/types";
import { AtsAcLdgr } from "../../supplier/queries/types";
import {
  AtsSubsidiary,
  AtsSubsidiarySite,
} from "../../subsidary/queries/types";
import {
  AtsCompany,
  TableType,
} from "../../../../customer/companies/queries/types";
import { AtsJunctions } from "../../../../../../queries/types";

export const GetItems = gql`
  query GetItems(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $orderBy: AtsStckItemOrder
    $name: String
    $input: ItemQueryData!
  ) {
    GetItems(
      token: $token
      after: $after
      customerID: $customerID
      companyID: $companyID
      first: $first
      orderBy: $orderBy
      input: $input
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          desc
          code
          slNo
          uom
          icon
          enableGst
          igst
          sgst
          cgst

          isStockOrService
          trackSerial
          trackBatch
          trackExpiry
          trackWarranty
          trackInstallation
          trackMaintenance
          isPerishable
          isConsumable
          imageNeeded
          trackAmc
          trackGeoLocation
          trackInsurance
          isModule
          isComponent
          image_path
          customerID
          stckCategoryID
          stckGroupID
          stckManufacturerID
          stckUomID
          categoryDetails {
            categoryName
          }
          subCategoryDetails {
            subCategoryName
          }
          groupDetails {
            groupName
          }
          manufacturerDetails {
            manufacturer
          }
          uomDetails {
            uom
          }
          ldgr_count
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetItemsDetailsForAutocomplete = gql`
  query GetItemsDetailsForAutocomplete(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $junctionID: ID!
    $siteID: ID!
    $input: ItemDetailsQuery!
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AtsStckItemDetailsOrder
    $name: String
  ) {
    GetItemsDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      input: $input
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      where: {
        or: [
          { prodSerialNoContainsFold: $name }
          { addressContainsFold: $name }
          { hasItemWith: { or: [{ descContainsFold: $name }] } }
        ]
      }
    ) {
      edges {
        node {
          id
          prodSerialNo
          prodModel
          alias
          poleNum
          address
          item {
            id
            desc
            code
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetItemsDetails = gql`
  query GetItemsDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $junctionID: ID!
    $siteID: ID!
    $input: ItemDetailsQuery!
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AtsStckItemDetailsOrder
    $name: String
  ) {
    GetItemsDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      input: $input
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      where: {
        or: [
          { prodSerialNoContainsFold: $name }
          { hasItemWith: { or: [{ descContainsFold: $name }] } }
        ]
      }
    ) {
      edges {
        node {
          id
          prodModel
          prodSerialNo
          alias
          prodExpiryDate
          prodBatchNo
          prodWarrantyStartDate
          prodWarrantyEndDate
          prodAmcStDate
          prodAmcEndDate
          prodInsuranceStDate
          prodInsuranceEndDate
          poleNum
          prodLatitude
          prodLongitude
          address
          ticketStatus
          prodInstallationEndDate
          ldgrID
          remark
          currentCompany {
            name
          }
          currentSubsidiary {
            name
          }
          currentSite {
            name
          }
          currentJunction {
            name
            poles
          }
          item {
            id
            desc
            code
            slNo
            uom
            enableGst
            igst
            sgst
            cgst
            isStockOrService
            trackSerial
            trackBatch
            trackExpiry
            trackWarranty
            trackInstallation
            trackMaintenance
            isPerishable
            isConsumable
            imageNeeded
            trackAmc
            trackGeoLocation
            trackInsurance
            isModule
            isComponent
            image_path
            customerID
            stckCategoryID
            stckGroupID
            stckManufacturerID
            stckUomID

            categoryDetails {
              categoryName
            }
            subCategoryDetails {
              subCategoryName
            }
            groupDetails {
              groupName
            }
            manufacturerDetails {
              manufacturer
            }
            uomDetails {
              uom
            }

            ldgr_count
          }
          vendorDetails {
            desc
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetItemsDetailsForGeolocation = gql`
  query GetItemsDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $junctionID: ID!
    $input: ItemDetailsQuery!
    $after: Cursor
    $first: Int
    $orderBy: AtsStckItemDetailsOrder
    $name: String
  ) {
    GetItemsDetails(
      token: $token
      after: $after
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      first: $first
      orderBy: $orderBy
      input: $input
      where: { or: [{ hasItemWith: [{ descContainsFold: $name }] }] }
    ) {
      edges {
        node {
          id
          prodSerialNo
          prodLatitude
          prodLongitude
          prodBrand
          ticketStatus
          currentCompany {
            id
            name
            address
            place
          }
          currentSubsidiary {
            id
            name
            place
          }
          item {
            id
            desc
            code
            slNo
            icon
            uom
            enableGst
            igst
            sgst
            cgst
            isStockOrService
            trackSerial
            trackBatch
            trackExpiry
            trackWarranty
            trackInstallation
            trackMaintenance
            isPerishable
            isConsumable
            imageNeeded
            trackAmc
            trackGeoLocation
            trackInsurance
            isModule
            isComponent
            image_path
            customerID
            stckCategoryID
            stckGroupID
            stckManufacturerID
            stckUomID
            categoryDetails {
              categoryName
            }
            subCategoryDetails {
              subCategoryName
            }
            groupDetails {
              groupName
            }
            manufacturerDetails {
              manufacturer
            }
            uomDetails {
              uom
            }

            ldgr_count
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
export const GetItemByNodeId = gql`
  query GetItemByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckItem {
        desc
        slNo
        code
        icon
        uom
        enableGst
        igst
        sgst
        cgst
        isStockOrService
        trackSerial
        trackBatch
        trackExpiry
        trackWarranty
        trackInstallation
        trackMaintenance
        isPerishable
        isConsumable
        imageNeeded
        trackAmc
        trackGeoLocation
        trackInsurance
        trackCalibration
        isModule
        isComponent
        image_path
        customerID
        stckCategoryID
        stckGroupID
        stckManufacturerID
        stckUomID
        additionalPropertyNeeded
        noOfAdditionalProperties
        AdditionalPropertyDesc1
        AdditionalPropertyDesc2
        AdditionalPropertyDesc3
        AdditionalPropertyDesc4
        AdditionalPropertyDesc5
        AdditionalPropertyDesc6
        AdditionalPropertyDesc7
        AdditionalPropertyDesc8
        AdditionalPropertyDesc9
        AdditionalPropertyDesc10
        AdditionalPropertyDatatype1
        AdditionalPropertyDatatype2
        AdditionalPropertyDatatype3
        AdditionalPropertyDatatype4
        AdditionalPropertyDatatype5
        AdditionalPropertyDatatype6
        AdditionalPropertyDatatype7
        AdditionalPropertyDatatype8
        AdditionalPropertyDatatype9
        AdditionalPropertyDatatype10
        stckDetailsEntryIsMultiple
        hsnCode
        trackBrand
        trackModel
      }
    }
  }
`;

export const GetItemsDetailsForMap = gql`
  query GetItemsDetailsForMap(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $junctionID: ID!
    $empID: ID!
    $ticketStatus: [TicketStatus!]!
  ) {
    GetItemsDetailsForMap(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      empID: $empID
      ticketStatus: $ticketStatus
    ) {
      id
      prodSerialNo
      prodLatitude
      prodLongitude
      ticketStatus
      curCompanyID
      item {
        icon
        desc
      }
    }
  }
`;

export const GetItemsDetailsForByJunction = gql`
  query GetItemsDetailsForByJunction(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $siteID: ID!
    $junctionID: ID!
    $empID: ID!
    $status: [TicketStatus!]!
  ) {
    GetItemsDetailsForByJunction(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      empID: $empID
      status: $status
    ) {
      prodSerialNo
      item {
        icon
      }
    }
  }
`;

export const GetDataForMaps = gql`
  query GetDataForMaps(
    $token: String!
    $customerID: ID!
    $input: MapsQueryData!
  ) {
    GetDataForMaps(token: $token, customerID: $customerID, input: $input) {
      companyID
      id
      latitude
      longitude
      ticketStatus
      icon
      name
      prodSerialNo
      desc
      address
    }
  }
`;

export const GetItemsForAutocomplete = gql`
  query GetItems(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $orderBy: AtsStckItemOrder
    $name: String
    $input: ItemQueryData!
  ) {
    GetItems(
      token: $token
      after: $after
      customerID: $customerID
      companyID: $companyID
      first: $first
      orderBy: $orderBy
      input: $input
      where: { or: [{ descContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          desc
          code
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetItemDescByNodeId = gql`
  query GetItemByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckItem {
        desc
        code
      }
    }
  }
`;

export const GetStckItemsForOb = gql`
  query GetItems(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckItemOrder
    $input: ItemQueryData!
    $name: String
    $hsnCode: String
  ) {
    GetItems(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      input: $input
      where: { or: [{ descContainsFold: $name, hsnCode: $hsnCode }] }
    ) {
      edges {
        node {
          id
          code
          desc
          groupDetails {
            groupName
          }
          categoryDetails {
            categoryName
          }
          inStockDetails {
            id
            stkOb
            stkIn
            stkObRate
          }
        }
      }
      pageInfo {
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GetItemNodeForStockEntry = gql`
  query GetItemByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckItem {
        desc
        code
        categoryDetails {
          categoryName
        }
        uom
        manufacturerDetails {
          manufacturer
        }
      }
    }
  }
`;

export const GetItemNodeForStockEntryViewAsset = gql`
  query GetItemByNodeId($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsStckItem {
        desc
        code
        enableGst
        categoryDetails {
          categoryName
        }
        uom
        manufacturerDetails {
          manufacturer
        }
        trackSerial
        trackBrand
        trackModel
        trackBatch
        trackExpiry
        trackWarranty
        trackInstallation
        trackMaintenance
        isPerishable
        isConsumable
        imageNeeded
        trackAmc
        trackGeoLocation
        trackInsurance
        isModule
        isComponent
        stckDetailsEntryNotNeeded
        stckDetailsEntryIsSingle
        stckDetailsEntryIsMultiple
        additionalPropertyNeeded
      }

      ... on AtsStckItem {
        desc
        code
        enableGst
        categoryDetails {
          categoryName
        }
        uom
        manufacturerDetails {
          manufacturer
        }
        trackSerial
        trackBrand
        trackModel
        trackBatch
        trackExpiry
        trackWarranty
        trackInstallation
        trackMaintenance
        isPerishable
        isConsumable
        imageNeeded
        trackAmc
        trackGeoLocation
        trackInsurance
        isModule
        isComponent
        stckDetailsEntryNotNeeded
        stckDetailsEntryIsSingle
        stckDetailsEntryIsMultiple
        additionalPropertyNeeded
      }
    }
  }
`;

export const GetStockCompanyItemLdgr = gql`
  query GetStockCompanyItemLdgr(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $companyID: ID!
    $orderBy: AtsStckCompanyItemLdgrOrder
    $input: ItemQueryData!
    $name: String
    $hsnCode: String
  ) {
    GetStockCompanyItemLdgr(
      token: $token
      after: $after
      input: $input
      customerID: $customerID
      companyID: $companyID
      first: $first
      orderBy: $orderBy
      where: {
        or: [{ hasItemWith: { or: [{ desc: $name, hsnCode: $hsnCode }] } }]
      }
    ) {
      edges {
        node {
          id
          stkOb
          stkIn
          stkObRate
          item {
            id
            code
            desc
            groupDetails {
              groupName
            }
            categoryDetails {
              categoryName
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const getItemDetailsByNode = gql`
  query getItemDetailsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemDetails {
        id
        prodSerialNo
        prodBatchNo
        prodExpiryDate
        prodWarrantyStartDate
        prodWarrantyEndDate
        prodLatitude
        prodLongitude
        prodInstallationEndDate
        prodModel
        currentSite {
          id
          name
          address
          place
        }
        item {
          id
          desc
          code
          icon
          uom
          trackSerial
          trackBatch
          trackExpiry
          trackWarranty
          trackGeoLocation
          trackInstallation
          categoryDetails {
            categoryName
          }
          subCategoryDetails {
            subCategoryName
          }
        }
        currentCompany {
          id
          name
          address
          place
        }
        currentSubsidiary {
          id
          name
          place
        }
        vendorDetails {
          desc
        }
      }
    }
  }
`;

export const getRetireItemDetailsByNode = gql`
  query getItemDetailsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckRetireItemDetails {
        id
        prodSerialNo
        prodBatchNo
        prodExpiryDate
        prodWarrantyStartDate
        prodWarrantyEndDate
        prodLatitude
        prodLongitude
        prodInstallationEndDate
        prodModel
        site {
          id
          name
          address
          place
        }
        item {
          id
          desc
          code
          icon
          uom
          trackSerial
          trackBatch
          trackExpiry
          trackWarranty
          trackGeoLocation
          trackInstallation
          categoryDetails {
            categoryName
          }
          subCategoryDetails {
            subCategoryName
          }
        }
        company {
          id
          name
          address
          place
        }
        subsidiaryDetails {
          id
          name
          place
        }
      }
    }
  }
`;

export const CompOrJuncOrAssetOrSubAndSiteNode = gql`
  query CompOrJuncOrAssetOrSubAndSiteNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      # ... on AtsCompany {
      #   name
      # }
      ... on AtsCompany {
        name
        latitude
        longitude
        icon
      }
      ... on AtsSubsidiary {
        name
        latitude
        longitude
        icon
        companyID
      }
      ... on AtsSubsidiarySite {
        name
        latitude
        longitude
        icon
        companyID
        subsidiary {
          name
        }
      }
      ... on AtsJunctions {
        name
        code
        priority
        latitude
        longitude
        icon
        companyID
        poles
        jType
        arms
        subsidiary {
          name
        }
        vendorDetails {
          desc
        }
        site {
          name
        }
      }
      ... on AtsStckItemDetails {
        prodSerialNo
        prodLatitude
        prodLongitude
        prodBatchNo
        prodExpiryDate
        prodWarrantyEndDate
        prodInstallationEndDate
        prodWarrantyEndDate
        curCompanyID
        poleNum
        item {
          id
          icon
          code
          desc
        }
        vendorDetails {
          desc
        }
        currentSubsidiary {
          name
        }
        currentSite {
          name
        }
      }
    }
  }
`;

export const GetItemOrSiteNode = gql`
  query GetItemOrSiteNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsStckItemDetails {
        id
        prodSerialNo
        prodBatchNo
        prodExpiryDate
        prodWarrantyStartDate
        prodWarrantyEndDate
        prodLatitude
        prodLongitude
        prodInstallationEndDate

        item {
          id
          desc
          code
          icon
          categoryDetails {
            categoryName
          }

          trackSerial
          trackBrand
          trackModel
          trackBatch
          trackExpiry
          trackWarranty
          trackInstallation
          trackMaintenance
          isPerishable
          isConsumable
          imageNeeded
          trackAmc
          trackGeoLocation
          trackInsurance
          isModule
          isComponent
          stckDetailsEntryNotNeeded
          stckDetailsEntryIsSingle
          stckDetailsEntryIsMultiple
          additionalPropertyNeeded
        }
        currentCompany {
          id
          name
          address
          place
        }
        currentSubsidiary {
          id
          name
          place
        }
      }
      ... on AtsSubsidiarySite {
        id
        name
        address
        company {
          id
          name
          address
          place
        }
        subsidiary {
          id
          name
          place
        }
      }
    }
  }
`;

export const GetTicketDetails = gql`
  query GetTicketDetails($token: String!, $customerID: ID!, $ticketID: ID!) {
    GetTicketDetails(
      token: $token
      customerID: $customerID
      ticketID: $ticketID
    ) {
      id
      slNo
      attendedDate
      completed
      anyChanges
      anySparesChanged
      status
      remarks
      attendedByID
      escaltedToID
      customerID
      companyID
      itemID
      itemDetailsID
      siteID
      ticketID
      ticket {
        ticketNo
        ticketDate
        reason
        type
        status
      }
    }
  }
`;

export const GetTicketDetailsForFollowUp = gql`
  query GetTicketDetailsForFollowUp(
    $token: String!
    $customerID: ID!
    $ticketID: ID!
  ) {
    GetTicketDetails(
      token: $token
      customerID: $customerID
      ticketID: $ticketID
    ) {
      id
      slNo
      status
      remarks
      imagesPath
      attendedDate
      companyID
      createdUserDetails {
        name
        empType
      }
      ticket {
        assignedUser {
          name
        }
        vendorDetails {
          id
        }
      }
    }
  }
`;

export const AtsTicketsByNode = gql`
  query AtsTicketsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        id
        ticketNo
        ticketDate
        reason
        type
        priority
        status
      }
    }
  }
`;

export const AtsTicketsByNodeForStatus = gql`
  query AtsTicketsByNodeForStatus($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        status
        junctionID
        companyID
        itemDetails {
          ldgrID
          initialJunction {
            ldgrID
          }
        }
        ticketDetails {
          id
        }
        vendorDetails {
          id
          includeDeviceType
        }
      }
    }
  }
`;

export const AtsTicketsByNodeForMaps = gql`
  query AtsTicketsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        id
        ticketNo
        status
        ticketDate
        reason
        item {
          manufacturerDetails {
            manufacturer
          }
        }
        ticketDetails {
          imagesPath
        }
        priority
        remarks
      }
    }
  }
`;

export const AtsTicketsForTicketDetailsByNode = gql`
  query AtsTicketsForTicketDetailsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        ticketDetails {
          id
          companyID
          attendedDate
          remarks
          status
          imagesPath
        }
      }
    }
  }
`;

export const TicketDetailsByNode = gql`
  query TicketDetailsByNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsTickets {
        ticketNo
        ticketDate
        reason
        itemDetails {
          vendorDetails {
            desc
          }
          prodSerialNo
        }
        priority
        assignedUser {
          name
        }
        loggedUser {
          id
          kgid
          metalNo
          name
          empType
          address
          place
          state
          pin
          email
          mobile
        }
        openRemarks
        orderedDetails {
          imagesPath
        }
        status
        item {
          icon
          desc
          slNo
        }
        vendorDetails {
          id
          desc
        }
      }
    }
  }
`;

export const GetCompanyIdByJunctionNode = gql`
  query GetCompanyIdByJunctionNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsJunctions {
        companyID
      }
    }
  }
`;

export const getJucntionWiseCustomerAndSoOn = gql`
  query getJucntionWiseCustomerAndSoOn($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      ... on AtsJunctions {
        name
        alias
        jType
        arms
        icon
        ticketStatus
        companyID
        vendorDetails {
          desc
        }
        company {
          name
        }
        subsidiary {
          name
        }
        site {
          name
        }
        customer {
          name
        }
      }
    }
  }
`;

export interface AtsTicketsByNodeData {
  node: {
    id: string;
    ticketNo: string;
    ticketDate: string;
    reason: string;
    type: string;
    priority: string;
    status: string;
    openRemarks: string;
    ticketDetails: AtsTicketDetails[];
    orderedDetails: AtsTicketDetails[];
    loggedUser: EmpMaster;
    itemDetails: AtsStckItemDetails;
    assignedUser: EmpMaster;
    item: AtsStckItem;
    vendorDetails: AtsAcLdgr;
    companyID: number;
    company: AtsCompany;
    subsidiaryDetails: AtsSubsidiary;
    junctionID: number;
    site: AtsSubsidiarySite;
    tableLevel: TableType;
    junction: AtsJunctions;
  };
}

export const JunctionsNode = gql`
  query JunctionsNode($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on AtsJunctions {
        name
        alias
        code
        arms
        priority
        poles
        vendorDetails {
          desc
        }
      }
    }
  }
`;

export const GetItemsDetailsForDashboard = gql`
  query GetItemsDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $junctionID: ID!
    $siteID: ID!
    $input: ItemDetailsQuery!
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AtsStckItemDetailsOrder
    $name: String
  ) {
    GetItemsDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      input: $input
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      where: { or: [{ hasItemWith: { or: [{ descContainsFold: $name }] } }] }
    ) {
      edges {
        node {
          id
          prodSerialNo
          ticketStatus
          item {
            id
            desc
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const JunctionOrAssetNodeById = gql`
  query JunctionOrAssetNodeById($token: String!, $id: ID!) {
    node(token: $token, id: $id) {
      id
      ... on AtsJunctions {
        name
        latitude
        longitude
        code
      }
      ... on AtsStckItemDetails {
        prodSerialNo
        prodLatitude
        prodLongitude
      }
    }
  }
`;

export const GetItemsDetailsForAlcometers = gql`
  query GetItemsDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $subsidiaryID: ID!
    $junctionID: ID!
    $siteID: ID!
    $input: ItemDetailsQuery!
    $after: Cursor
    $first: Int
    $before: Cursor
    $last: Int
    $orderBy: AtsStckItemDetailsOrder
    $name: String
  ) {
    GetItemsDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      subsidiaryID: $subsidiaryID
      siteID: $siteID
      junctionID: $junctionID
      input: $input
      after: $after
      first: $first
      before: $before
      last: $last
      orderBy: $orderBy
      where: { or: [{ prodSerialNoContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          prodSerialNo
          calibrationCount
          currentBlowCount
          item {
            id
            desc
            code
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetCalibrationDetails = gql`
  query GetCalibrationDetails(
    $token: String!
    $itemDetailsID: ID!
    $itemID: ID!
    $customer_id: ID!
    $after: Cursor
    $first: Int
    $orderBy: AtsCalibrationDetailsOrder
  ) {
    GetCalibrationDetails(
      token: $token
      itemDetailsID: $itemDetailsID
      itemID: $itemID
      customer_id: $customer_id
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          blowDate
          blowCount
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetBlowCountDetails = gql`
  query GetBlowCountDetails(
    $token: String!
    $itemDetailsID: ID!
    $itemID: ID!
    $empID: ID!
    $customer_id: ID!
    $after: Cursor
    $todaysDate: Time
    $first: Int
    $orderBy: AtsCalibrationDetailsOrder
    $name: String!
  ) {
    GetBlowCountDetails(
      token: $token
      itemDetailsID: $itemDetailsID
      itemID: $itemID
      customer_id: $customer_id
      empID: $empID
      todaysDate: $todaysDate
      after: $after
      first: $first
      orderBy: $orderBy
      where: {
        or: [
          { hasItemDetailsWith: { or: [{ prodSerialNoContainsFold: $name }] } }
        ]
      }
    ) {
      edges {
        node {
          id
          blowDate
          blowCount
          itemDetails {
            prodSerialNo
            calibrationCount
            currentBlowCount
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetBlowCountDetailsForUpdate = gql`
  query GetBlowCountDetails(
    $token: String!
    $itemDetailsID: ID!
    $customer_id: ID!
    $after: Cursor
    $todaysDate: Time
    $first: Int
    $orderBy: AtsCalibrationDetailsOrder
  ) {
    GetBlowCountDetails(
      token: $token
      itemDetailsID: $itemDetailsID
      customer_id: $customer_id
      todaysDate: $todaysDate
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      edges {
        node {
          id
          blowDate
          blowCount
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const GetAlcometerDetail = gql`
  query GetAlcometerDetail($token: String!, $customerID: ID!) {
    GetAlcometerDetail(token: $token, customerID: $customerID) {
      id
      desc
      code
    }
  }
`;
